import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class BlendMode extends BaseOption {
  static userInterfaceComponent = {
    label: "Blend Mode",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [
        {
          name: "Normal",
          id: "normal",
        },
        {
          name: "Multiply",
          id: "multiply",
        },
        {
          name: "Screen",
          id: "screen",
        },
        {
          name: "Overlay",
          id: "overlay",
        },
        {
          name: "Darken",
          id: "darken",
        },
        {
          name: "Lighten",
          id: "lighten",
        },
        {
          name: "Color-Dodge",
          id: "color-dodge",
        },
        {
          name: "Color-Burn",
          id: "color-burn",
        },
        {
          name: "Hard-Light",
          id: "hard-light",
        },
        {
          name: "Soft-Light",
          id: "soft-light",
        },
        {
          name: "Difference",
          id: "difference",
        },
        {
          name: "Exclusion",
          id: "exclusion",
        },
        {
          name: "Hue",
          id: "hue",
        },
        {
          name: "Saturation",
          id: "saturation",
        },
        {
          name: "Color",
          id: "color",
        },
        {
          name: "Luminosity",
          id: "luminosity",
        },
        {
          name: "Initial",
          id: "initial",
        },
        {
          name: "Inherit",
          id: "inherit",
        },
        {
          name: "Unset",
          id: "unset",
        },
      ],
    },
  };

  static defaultValue = "unset";
}
